<template>
    <div class="form">
        <h4 class="step-title">
            What is your gender?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="genders" v-bind:onclick="genderComplete" v-bind:value="lead.gender"/>
            <div class="step-item" v-if="genderRequired && lead.gender === null">
                <div class="alert alert-danger">Gender required</div>
            </div>
        </div>
        <h4 class="step-title">
            Are you married?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <yes-no-button-list v-bind:onclick="isMarriedComplete" v-bind:value="lead.isMarried"/>
            <div class="step-item" v-if="isMarriedRequired && lead.isMarried === null">
                <div class="alert alert-danger">Marriage required</div>
            </div>
        </div>
        <h4 class="step-title">
            What is your credit rating?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <scrollable-button-list v-bind:items="creditRatings" v-bind:onclick="creditRatingComplete" v-bind:value="lead.creditRating"/>
            <div class="step-item" v-if="genderRequired && lead.gender === null || isMarriedRequired && lead.isMarried === null">
                <div class="alert alert-danger">Required question(s) not answered</div>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"
    import YesNoButtonList from "./shared/YesNoButtonList.vue"
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"

    export default {
        name: "GenderIsMarriedCreditRating",
        components: {
            ButtonList,
            YesNoButtonList,
            ScrollableButtonList
        },
        data: function() {
            return {
                genders: [
                    { text: "Male", value: "Male" },
                    { text: "Female", value: "Female" }
                ],
                creditRatings: [
                    { text: "Excellent", value: "Excellent" },
                    { text: "Good", value: "Good" },
                    { text: "Average", value: "Okay" },
                    { text: "Below Average", value: "BelowAverage" },
                    { text: "Poor", value: "Poor" }
                ],
                genderRequired: false,
                isMarriedRequired: false
            }
        },
        props: {
            lead: Object
        },
        methods: {
            genderComplete: function(value) {
                this.lead.gender = value;

                if (this.genderRequired && this.lead.isMarried !== null && this.lead.creditRating !== null) {
                    this.complete(this.lead.creditRating);
                }
            },
            isMarriedComplete: function(value) {
                this.lead.isMarried = value;

                if (this.isMarriedRequired && this.lead.gender !== null && this.lead.creditRating !== null) {
                    this.complete(this.lead.creditRating);
                }
            },
            creditRatingComplete: function(value) {
                if (this.lead.gender === null) {
                    this.genderRequired = true;
                }

                if (this.lead.isMarried === null) {
                    this.isMarriedRequired = true;
                }

                this.lead.creditRating = value;

                if (this.lead.gender !== null && this.lead.isMarried !== null) {
                    this.complete(value);
                }
            },
            complete: function(creditRatingValue) {
                this.$emit("complete", this.$options.name, creditRatingValue);
            }
        }
    }
</script>
